import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth-service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('zaid-front');

  private authService = inject(AuthService);

  constructor() {
    this.authService.refreshToken().pipe(take(1)).subscribe({
      next: (res) => {
        this.authService.setAccessToken(res.accessToken);
        this.authService.fetchCurrentUser().pipe(take(1)).subscribe();
      },
      error: () => {      }
    });
  }
} 